import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxSpinnerModule} from 'ngx-spinner';

import {FormModule} from '@sim/form';
import {MediaModule} from '@sim/media';
import {RoleModule} from '@sim/role';
import {UsersModule} from '@sim/users';

import {environment} from '@src/environments/environment';

import {AppRoutingModule} from '@atmi/app-routing.module';
import {CoreModule} from '@atmi/core';

import {MatStepperModule} from '@angular/material/stepper';
import {AppComponent} from '@atmi/app.component';
import {
  CollectionExportDialogComponent
} from './features/collections/dialogs/collection-export-dialog/collection-export-dialog.component';

import {CollectionPrintComponent} from './features/collections/components/collection-print/collection-print.component';

import {AddSourceArchDialogComponent} from './shared/add-source-arch-dialog/add-source-arch-dialog.component';

import {MatIconModule} from '@angular/material/icon';

import {AuthModule} from '@atmi/pages/auth/auth.module';
import {SharedModule} from '@atmi/shared';
import {TranslateModule} from '@ngx-translate/core';
import {UiModule} from '@ui/ui.module';
import {AddBaseDialogComponent} from './shared/add-base-dialog/add-base-dialog.component';

import {DragDropModule} from '@angular/cdk/drag-drop';
import {NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask, provideNgxMask} from "ngx-mask";

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    CollectionExportDialogComponent,
    CollectionPrintComponent,
    AddSourceArchDialogComponent,
    AddBaseDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    MatSnackBarModule,
    MatButtonModule,
    AppRoutingModule,
    RoleModule.forRoot({basePath: environment.basePath}),
    UsersModule.forRoot({basePath: environment.basePath}),
    MediaModule.forRoot({basePath: environment.basePath, resourcePath: '/files'}),
    CoreModule.forRoot(),
    FormModule.forRoot(),
    MatStepperModule,
    MatInputModule,
    MatSlideToggleModule,
    MatCardModule,
    MatSelectModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatTabsModule,
    SharedModule,
    TranslateModule,
    UiModule,
    AuthModule,
    MatListModule,
    DragDropModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [provideNgxMask()],
  exports: []
})
export class AppModule {
}
